"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right20"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down20"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].header,
    onClick: function onClick() {
      return props.handleCollapse(props.id);
    }
  }, props.collapsed.includes(props.id) ? /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], {
    spaceRight: true
  }) : /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], {
    spaceRight: true
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].headerText
  }, props.title)), !props.collapsed.includes(props.id) && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].content
  }, props.children));
};